<template>
    <li class="vue-notification-indicator">
        <a href="#" class="indicator-handle" data-toggle="dropdown" @click.prevent="toggleVisibility">
            <span class="glyphicon glyphicon-comment menu-glyphicon"></span>

            <span class='badge progress-bar-info' v-if="hasNotifications">{{this.items.length}}</span>
        </a>

        <div v-if="hasNotifications" :style="{display: listVisible ? 'block' : 'none'}" class="dropdown-menu notification-list-container">
            <h4>Notifications</h4>
            <div class="errorMsg bg-danger well-sm" v-if="this.errorMsg.length">
                {{this.errorMsg}}
            </div>
            <ul class='list-group' v-if="hasNotifications">
                <template v-for="(i,k) in this.items" >
                    <li v-if="fuzzyTimeMatch(k)"><h5>{{fuzzyTime(i.updatedAt)}}</h5></li>
                    <li class="list-group-item notification-container" :class="{ targeted: i.targeted }">
                        <NotificationStandard :item="i" v-if="i.type === 'Standard'" @notification:deleted="deleteItem" @notification:targeted="toggleItemVisibility"></NotificationStandard>
                        <NotificationProgressErrors :item="i" v-if="i.type === 'ProgressErrors'" @notification:deleted="deleteItem" @notification:targeted="toggleItemVisibility"></NotificationProgressErrors>
                        <NotificationPricingNoted :item="i" v-else-if="i.type === 'PricingNoted'" @notification:deleted="deleteItem" @notification:targeted="toggleItemVisibility"></NotificationPricingNoted>
                        <NotificationPricingCompleted :item="i" v-else-if="i.type === 'PricingCompleted'" @notification:deleted="deleteItem" @notification:targeted="toggleItemVisibility"></NotificationPricingCompleted>
                        <NotificationPricingRejected :item="i" v-else-if="i.type === 'PricingRejected'" @notification:deleted="deleteItem" @notification:targeted="toggleItemVisibility"></NotificationPricingRejected>
                        <span v-else>{{i.title}}</span>
                    </li>
                </template>
            </ul>
        </div>
    </li>
</template>

<script>
    import axios from '@/api/client'
    import NotificationStandard from '@/components/notifications/behaviors/Standard'
    import NotificationProgressErrors from '@/components/notifications/behaviors/ProgressErrors'
    import NotificationPricingCompleted from '@/components/notifications/behaviors/PricingCompleted'
    import NotificationPricingNoted from '@/components/notifications/behaviors/PricingNoted'
    import NotificationPricingRejected from '@/components/notifications/behaviors/PricingRejected'

    export default {
        props: {
            destinationPath: {
                type: String,
                required: true
            },
            userId: {
                type: Number,
                required: true
            }
        },
        name: 'Notifications',
        data () {
            return {
                items: [],
                listVisible: false,
                errorMsg: ''
            }
        },
        computed: {
            hasNotifications: function () {
                return this.items.length > 0 || this.errorMsg.length
            }
        },
        methods: {
            toggleVisibility: function (e) {
                this.listVisible = !this.listVisible

                if (this.listVisible) {
                    document.addEventListener('click', this.hide)
                    document.addEventListener('keyup', this.hide)
                } else {
                    document.removeEventListener('click', this.hide)
                    document.removeEventListener('keyup', this.hide)
                }
            },
            toggleItemVisibility (item) {
                this.items.forEach((i, k) => {
                    if (i.id === item.id) {
                        this.$set(this.items[k], 'targeted', !item.targeted)
                    } else {
                        this.$set(this.items[k], 'targeted', false)
                    }
                })
            },
            deleteItem: async function (item) {
                try {
                    this.errorMsg = ''
                    const response = await axios.delete('/rest/user/' + this.userId + '/notifications/' + item.id)

                    if (response.data.result !== true) {
                        this.errorMsg = response.data.message
                    }
                } catch (err) {
                    this.errorMsg = err.message
                }
            },
            hide (e) {
                if (this.listVisible && !this.$el.contains(e.target)) {
                    this.toggleVisibility(e)
                }
            },
            fuzzyTimeMatch (index) {
                if (index === 0) {
                    return true
                } else {
                    return !(this.fuzzyTime(this.items[index].updatedAt) === this.fuzzyTime(this.items[index - 1].updatedAt))
                }
            },
            fuzzyTime (timestamp, now) {
                if (timestamp === null || timestamp === undefined || timestamp === '') {
                    return ''
                }

                console.log(timestamp)

                const parts = {
                    Second: 60,
                    Minute: 60,
                    Hour: 24,
                    Day: 7,
                    Week: 365 / 7 / 12,
                    Month: 12
                }

                let date = new Date(timestamp)

                if (now !== null && now !== undefined && now !== '') {
                    now = new Date(now)
                } else {
                    now = new Date()
                }

                let diff = (now - date) / 1000
                let part = 0

                if (diff < 120) {
                    return 'Just Now'
                } else {
                    for (let timepart in parts) {
                        part = diff % parts[timepart]
                        diff = (diff - part) / parts[timepart]

                        if (diff === 0) {
                            if (part === 1) {
                                return part + ' ' + timepart + ' Ago'
                            } else {
                                return part + ' ' + timepart + 's Ago'
                            }
                        }
                    }

                    return 'Years Ago'
                }
            },
            getMessageListener () {
                const self = this

                return function (event) {
                    if (Array.isArray(event.data)) {
                        self.items = event.data.filter(datum => {
                            return (datum.module === 'Notifications')
                        })
                    } else {
                        if (event.data.mode === 'delete') {
                            self.items = self.items.filter(datum => {
                                return (datum.id !== event.data.payload.id)
                            })
                        } else if (event.data.payload.module === 'Notifications') {
                            if (event.data.mode === 'update') {
                                for (let item in self.items) {
                                    if (self.items[item].id === event.data.payload.id) {
                                        self.items[item] = event.data.payload
                                    }
                                }
                            } else {
                                self.items.push(event.data.payload)
                            }
                        }
                    }
                }
            }
        },
        created () {
            if ('serviceWorker' in navigator) {
                // Handler for messages coming from the service worker
                navigator.serviceWorker.addEventListener('message', this.getMessageListener())
            }
        },
        mounted () {
//            this.toggleVisibility()
        },
        components: { NotificationStandard, NotificationProgressErrors, NotificationPricingCompleted, NotificationPricingNoted, NotificationPricingRejected }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.vue-notification-indicator .notification-list-container {
    padding:0;
}

.vue-notification-indicator .notification-list-container > *{
    margin-left: 15px;
}

.vue-notification-indicator .notification-list-container .list-group {
    padding: 0;
    border: 0;
    margin:0;
}

.vue-notification-indicator .badge {
    position: absolute;
    top: 40%;
    right: 10%;
    font-size:0.7em;
}

.vue-notification-indicator .indicator-handle {
    position: relative;
}
</style>



// WEBPACK FOOTER //
// Notifications.vue?6ab1db2e